// src/services/api/offlineSales/deliveryNotes.js
// Endpoints per rettzy-backend/src/modules/offlineSales/routes/deliveryNote.routes.js
import { apiClient } from '../base';

export const getDeliveryNotes = async (params = {}) => {
  const response = await apiClient.get('/offline-sales/delivery-notes', { params });
  return response.data;
};

export const getDeliveryNote = async (deliveryNoteId) => {
  const response = await apiClient.get(`/offline-sales/delivery-notes/${deliveryNoteId}`);
  return response.data;
};

export const createDeliveryNote = async (data) => {
  const response = await apiClient.post('/offline-sales/delivery-notes', data);
  return response.data;
};
